/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class DestinationProviderAttributesAzure {
  /**
  * Name of the resource group to restore to.
  */
  'resourceGroup'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceGroup",
      "baseName": "resourceGroup",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DestinationProviderAttributesAzure.attributeTypeMap;
  }

  public constructor() {
  }
}

